import React from 'react';
import { useNavigate } from 'react-router';
import { ArrowUpRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

/**
 * Mirrors coms `agent/actionResults.ts` ActionResult — persisted on assistant
 * messages as `actions`.
 */
export interface ChatActionResult {
  tool: string;
  label: string;
  url: string;
  record_id?: string;
}

interface ActionResultCardProps {
  actions: ChatActionResult[] | undefined;
}

/** Only in-app routes are navigable; anything else is ignored defensively. */
const isAppPath = (url: string): boolean =>
  url.startsWith('/') && !url.startsWith('//');

/**
 * "Open in app" buttons for tool results that produced something the user
 * should review (e.g. a drafted Event Settings rule). Rendered under the
 * assistant message in both the legacy chat and the V2 message list.
 */
export const ActionResultCard: React.FC<ActionResultCardProps> = ({
  actions,
}) => {
  const navigate = useNavigate();
  const items = (actions ?? []).filter((a) => a && isAppPath(a.url));
  if (items.length === 0) return null;

  return (
    <div
      className="tw:mt-2 tw:flex tw:flex-wrap tw:gap-2"
      data-testid="action-result-card"
    >
      {items.map((action) => (
        <Button
          key={`${action.tool}:${action.url}`}
          type="button"
          size="sm"
          variant="secondary"
          onClick={() => navigate(action.url)}
          data-testid={`action-result-${action.tool}`}
        >
          {action.label}
          <ArrowUpRight aria-hidden="true" />
        </Button>
      ))}
    </div>
  );
};

export default ActionResultCard;
